<template>
  <div class="app">
    <router-link to="/PaymentCode" class="nav" :class="{col:message=='1'}">
      <div class="tu">
        <i class="iconfont icontiaoma" ></i>
      </div>
      <div class="zi">
        <span>付款码</span>
      </div>
    </router-link>
    <router-link to="/CardKeyDetails" class="nav" :class="{col:message=='2'}">
      <div class="tu">
        <i class="iconfont iconkahao"></i>
      </div>
      <div class="zi">
        <span>卡号密钥</span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
  data () {
    return {
    }
  },
  props: ["message"],
  mounted(){
  },
  methods:{
    clickStyle(val){
      console.log(val)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.app{
  background:#fff;
  height:40px;
  width:100%;
}
.nav{
   width:50%;  
   text-align: center;
   color:#212121;
   height:40px;
   display: block;
   float: left;
   text-decoration:none;
}
.tu{
  height:25px;
  line-height: 25px;
}
.iconfont{
  font-size:22px;
}
.zi{
  height:15px;
  line-height: 15px;
}
.zi>span{
  font-size:8px;
}
.col{
  color:#46a1ff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue